import RNClipboard from '@react-native-clipboard/clipboard'

export const Clipboard = RNClipboard
